import { CenterProps } from '@mantine/core';
import { IconMove } from 'ui-icons';

import { DraggableProvided } from '../../../DragAndDrop';
import { Center } from '../../../Layout/Center';

type DraggableHandleProps = {
  provided: DraggableProvided;
  isDraggable?: boolean;
} & CenterProps;

const DraggableHandle = ({ provided, isDraggable = true, ...rest }: DraggableHandleProps) => {
  if (!isDraggable) return null;
  return (
    <Center style={{ flexGrow: 0 }} {...provided.dragHandleProps} {...rest}>
      <IconMove color="#CCCCCC" />
    </Center>
  );
};

export { DraggableHandle };
export type { DraggableHandleProps };
